export default function calculateAdTotal(days, pricePerDay = 250) {
  if (Number.isNaN(days)) return 0;

  return days * pricePerDay;
}
